



















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';

@Component
export default class DrawerComponent extends Vue {
  @Prop(Array) readonly items!: string;
  private mini = null;
  private profile = '';
  private loading = false;

  private get user() {
    return this.refs.modules.user.userInfo;
  }

  private get refs() {
    return refsService;
  }

  private async mounted() {
    this.loading = true;
    await this.refs.modules.company.loadActivationsByAccountId();
    if (!this.refs.modules.company.applicationPermitted) {
      this.$toast(this.$t('toasts.application_access_not_permitted'), {
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        onClose: () => this.$router.push({ name: 'logout' }),
      });
    }
    const emailModel = this.refs.util.findEmail(
      this.refs.modules.contract.customer.Contacts
    );
    if (typeof emailModel?.Value != undefined && emailModel?.Value) {
      await this.refs.modules.company.getProvidersByAccoundId();
      await this.refs.modules.notify.GetProviders();
    }
    this.loading = false;
  }

  private get applications() {
    return this.refs.modules.company.applicationsFiltered;
  }
  private get profiles() {
    const result = this.refs.modules.user.profiles;
    if (!this.user.owner) this.profile = result[0]?.AccountId;
    return result;
  }
}
